// EU keyboards emit a comma decimal separator, which bare Number() reads as NaN
export const parseNumericInput = (input: string): number =>
  Number(input.trim().replace(',', '.'));
